const initSliderEventsMain = () => {
  if (!document.querySelector('.po-event-slider__slider .splide')) {
    return;
  }

  new Splide('.po-event-slider__slider .splide', {
    // type: 'loop',
    perPage: 2,
    perMove: 1,
    gap: '20px',
    focus: 0,
    // focusable: false,
    breakpoints: {
      1280: { perPage: 2, padding: { left: 20, right: 20 } },
      780: { perPage: 1.25, padding: { left: 20, right: 20 } },
    },
  }).mount();
}
export { initSliderEventsMain };